import { ComplexValue } from 'app/types-shared';
import { FavouriteItem, FavouriteItemValidation } from './types-store';

export const ACTION = {
  REQUEST_LANGUAGE_OPTIONS: 'FAVOURITE_ADMIN_FORM:REQUEST_LANGUAGE_OPTIONS',
  RECEIVE_LANGUAGE_OPTIONS: 'FAVOURITE_ADMIN_FORM:RECEIVE_LANGUAGE_OPTIONS',
  FAIL_LANGUAGE_OPTIONS: 'FAVOURITE_ADMIN_FORM:FAIL_LANGUAGE_OPTIONS',

  REQUEST_FAVOURITE: 'FAVOURITE_ADMIN_FORM:REQUEST_FAVOURITE',
  RECEIVE_FAVOURITE: 'FAVOURITE_ADMIN_FORM:RECEIVE_FAVOURITE',
  FAIL_FAVOURITE: 'FAVOURITE_ADMIN_FORM:FAIL_FAVOURITE',

  REQUEST_DELETE_FAVOURITE: 'FAVOURITE_ADMIN_FORM:REQUEST_DELETE_FAVOURITE',
  RECEIVE_DELETE_FAVOURITE: 'FAVOURITE_ADMIN_FORM:RECEIVE_DELETE_FAVOURITE',
  FAIL_DELETE_FAVOURITE: 'FAVOURITE_ADMIN_FORM:FAIL_DELETE_FAVOURITE',

  REQUEST_SAVE_FAVOURITE: 'FAVOURITE_ADMIN_FORM:REQUEST_SAVE_FAVOURITE',
  RECEIVE_SAVE_FAVOURITE: 'FAVOURITE_ADMIN_FORM:RECEIVE_SAVE_FAVOURITE',
  FAIL_SAVE_FAVOURITE: 'FAVOURITE_ADMIN_FORM:FAIL_SAVE_FAVOURITE',

  REQUEST_DELETE_SCHEDULE: 'FAVOURITE_ADMIN_FORM:REQUEST_DELETE_SCHEDULE',
  RECEIVE_DELETE_SCHEDULE: 'FAVOURITE_ADMIN_FORM:RECEIVE_DELETE_SCHEDULE',
  FAIL_DELETE_SCHEDULE: 'FAVOURITE_ADMIN_FORM:FAIL_DELETE_SCHEDULE',

  CLEAR_FORM: 'FAVOURITE_ADMIN_FORM:CLEAR_FORM',
  UPDATE_ITEM: 'FAVOURITE_ADMIN_FORM:UPDATE_ITEM',
  
  CHANGE_LANGUAGE: 'FAVOURITE_ADMIN_FORM:CHANGE_LANGUAGE',
  COPY_LANGUAGE_TO_ALL: 'FAVOURITE_ADMIN_FORM:COPY_LANGUAGE_TO_ALL',

  CHANGE_LONG_DESCRIPTION: 'FAVOURITE_ADMIN_FORM: CHANGE_LONG_DESCRIPTION',
  COPY_LONG_DESCRIPTION_TO_ALL: 'FAVOURITE_ADMIN_FORM:COPY_LONG_DESCRIPTION_TO_ALL',

  UPDATE_VALIDATION: 'FAVOURITE_ADMIN_FORM:UPDATE_VALIDATION',
  RESET_VALIDATION: 'FAVOURITE_ADMIN_FORM:RESET_VALIDATION'
};

export class RequestLanguageOptions {
  public type: string = ACTION.REQUEST_LANGUAGE_OPTIONS;
}

export class ReceiveLanguageOptions {
  public type: string = ACTION.RECEIVE_LANGUAGE_OPTIONS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailLanguageOptions {
  public type: string = ACTION.FAIL_LANGUAGE_OPTIONS;
}

export class RequestFavourite {
  public type: string = ACTION.REQUEST_FAVOURITE;
  constructor(public id: number) { }
}

export class ReceiveFavourite {
  public type: string = ACTION.RECEIVE_FAVOURITE;
  constructor(
    public id: number,
    public item: FavouriteItem
  ) { }
}

export class FailFavourite {
  public type: string = ACTION.FAIL_FAVOURITE;
  constructor(public id: number) { }
}

export class RequestDeleteFavourite {
  public type: string = ACTION.REQUEST_DELETE_FAVOURITE;
  constructor(public id: number) { }
}

export class ReceiveDeleteFavourite {
  public type: string = ACTION.RECEIVE_DELETE_FAVOURITE;
  constructor(public id: number) { }
}

export class FailDeleteFavourite {
  public type: string = ACTION.FAIL_DELETE_FAVOURITE;
  constructor(public id: number) { }
}

export class RequestSaveFavourite {
  public type: string = ACTION.REQUEST_SAVE_FAVOURITE;
  constructor(public id: number) { }
}

export class ReceiveSaveFavourite {
  public type: string = ACTION.RECEIVE_SAVE_FAVOURITE;
  constructor(public id: number, public newFavouriteId: number) { }
}

export class FailSaveFavourite {
  public type: string = ACTION.FAIL_SAVE_FAVOURITE;
  constructor(public id: number) { }
}

export class RequestDeleteSchedule {
  public type: string = ACTION.REQUEST_DELETE_SCHEDULE;
  constructor(public id: number) { }
}

export class ReceiveDeleteSchedule {
  public type: string = ACTION.RECEIVE_DELETE_SCHEDULE;
  constructor(public id: number) { }
}

export class FailDeleteSchedule {
  public type: string = ACTION.FAIL_DELETE_SCHEDULE;
  constructor(public id: number) { }
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class UpdateItem {
  public type: string = ACTION.UPDATE_ITEM;
  constructor(public item: Partial<FavouriteItem>) { }
}

export class ChangeLanguage {
  public type: string = ACTION.CHANGE_LANGUAGE;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLanguageToAll {
  public type: string = ACTION.COPY_LANGUAGE_TO_ALL;
  constructor(public languageId: number) { }
}

export class ChangeLongDescription {
  public type: string = ACTION.CHANGE_LONG_DESCRIPTION;
  constructor(public languageId: number, public description: string) { }
}

export class CopyLongDescriptionToAll {
  public type: string = ACTION.COPY_LONG_DESCRIPTION_TO_ALL;
  constructor(public languageId: number) { }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: FavouriteItemValidation) { }
}

export class ResetValidation {
  public type: string = ACTION.RESET_VALIDATION;
  constructor(public key: string) {
  }
}
